import React from 'react';

export const PageNotFound = () => {
  return (
    <div style={{margin: 0}}>
      <div style={{fontWeight: "bold", fontSize: 200}}>404</div>
    </div>
  )
}
